import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// solid
import {
  faListDropdown as fasListDropdown,
  faListTree as fasListTree,
  faUtensils as fasUtensils,
  faGear as fasGear,
  faUsers as fasUsers,
  faTruck as fasTruck,
  faFrenchFries as fasFrenchFries,
  faComputer as fasComputer,
  faText as fasText,
  faRightFromBracket as fasRightFromBracket,
  faBurger as fasBurger,
  faArrowUp as fasArrowUp,
  faArrowDown as fasArrowDown,
  faTablePicnic as fasTablePicnic,
} from "@fortawesome/pro-solid-svg-icons";

// Install font awesome pack
export default (app) => {
  library.add(fasTablePicnic);
  library.add(fasArrowUp);
  library.add(fasArrowDown);
  library.add(fasBurger);
  library.add(fasRightFromBracket);
  library.add(fasText);
  library.add(fasComputer);
  library.add(fasListDropdown);
  library.add(fasListTree);
  library.add(fasUtensils);
  library.add(fasGear);
  library.add(fasUsers);
  library.add(fasTruck);
  library.add(fasFrenchFries);

  app.component("font-awesome-icon", FontAwesomeIcon);
};
